export const GET_LIST = '/building/get_list';
export const SHOW_DATA = '/building/show_data';
export const CREATE_DATA = '/building/create_data';
export const UPDATE_DATA = '/building/update_data';
export const GET_ACTUAL_USE_LIST = '/land/get_actual_use';

export const FORM_DATA = {
  name: '',
  description: '',
  is_active: false,
};